export default __webpack_public_path__ + "static/favicon-837cb4ad7bd70ca2dcc3cb0fe3babc9f.svg";